import { observable, action } from 'mobx';
import URIs from 'const/URIs';
import request from 'utils/request';
import PdfUtils from 'utils/PdfUtils';
import { ChangeEvent } from 'react';

export default class FileUpload {
  @observable isLoading: boolean = false;
  @observable isBlock: boolean = false;
  @observable isFileUpload: boolean = false;
  @observable fileName: string = '';
  @observable errorMsg: string = '';
  @observable slides: string[] = [];
  @observable totalPage: number = 1;
  @observable loadingPage: number = 0;

  @action onPdfFileChange = async (event: any) => {
    let file = event.target.files[0];
    if (file) {
      this.isLoading = true;
      let fileSize = file.size;
      var _fileLen = file.name.length;
      var _lastDot = file.name.lastIndexOf('.');
      var _fileExt = file.name.substring(_lastDot, _fileLen).toLowerCase();
      if(_fileExt!=='.pdf'){
        this.isLoading = false;
        this.isBlock = true;
        this.errorMsg = `최대 10MB 용량의 PDF 파일만 업로드 가능합니다.`; 
        return;
      }


      if (fileSize > 10 * 1024 * 1000) {
        this.isLoading = false;
        this.isBlock = true;
        this.errorMsg = `최대 10MB 용량의 PDF 파일만 업로드 가능합니다.`;
        return;
      }

      try {
        const doc = await PdfUtils.pdfFile2Doc(file);
        this.totalPage = doc.numPages;
        for(let i = 0; i < doc.numPages; i++) {
          this.loadingPage = i+1;
          const canvas = await PdfUtils.pdfDoc2CanvasPage(doc, i);
          if(i === 0) {
            this.slides = [];
          }
          this.slides.push(canvas.toDataURL());
        }

        const data = new FormData();
        data.append('file', file);
        await request({
          method: 'post',
          url: URIs.pdf_upload,
          data: data,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(async response => {
          this.fileName = file.name;
          this.isFileUpload = true;
        })
        .catch(({ response }) => {
          this.errorMsg = response.data.message;
          if(!response || !response.data.message) {
            this.errorMsg = `발표자료를 확인하고 다시 업로드하세요.`;
          }
          this.isLoading = false;
          this.isBlock = true;
          this.slides = [];
          // throw(response);
        })
        .finally(() => {
          this.isLoading = false;
        });
      } catch(e) {
        this.isLoading = false;
        this.isBlock = true;
        this.errorMsg = `발표자료를 확인하고 다시 업로드하세요.`;
        this.slides = [];
        console.error(e);
      } finally {
        this.isLoading = false;
        this.loadingPage=0;
        this.totalPage=1;
      }
    }

  };
}
